var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.activity.type === _vm.ActivityTypes.USER_STATUS_CHANGED.id
    ? _c("UserStatusChanged", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.BLOCK_VISITOR.id
    ? _c("VisitorBlocked", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.UNBLOCK_VISITOR.id
    ? _c("VisitorUnBlocked", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.VISITOR_TAG_ADDED.id
    ? _c("VisitorTagAdded", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.VISITOR_TAG_REMOVED.id
    ? _c("VisitorTagRemoved", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.USER_ADDED.id
    ? _c("UserAdded", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.CHANNEL_CREATED.id
    ? _c("ChannelCreated", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.CHANNEL_REMOVED.id
    ? _c("ChannelRemoved", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.CHAT_OPENED.id
    ? _c("ChatOpened", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.CHAT_CLOSED.id
    ? _c("ChatClosed", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.WEBHOOK_ADDED.id
    ? _c("WebhookAdded", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.WEBHOOK_REMOVED.id
    ? _c("WebhookRemoved", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.WEBHOOK_UPDATED.id
    ? _c("WebhookUpdated", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.TRIGGER_ADDED.id
    ? _c("TriggerAdded", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.TRIGGER_REMOVED.id
    ? _c("TriggerRemoved", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.TRIGGER_UPDATED.id
    ? _c("TriggerUpdated", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.DEPARTMENT_ADDED.id
    ? _c("DepartmentAdded", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.DEPARTMENT_REMOVED.id
    ? _c("DepartmentRemoved", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.ROLE_ADDED.id
    ? _c("RoleAdded", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.ROLE_REMOVED.id
    ? _c("RoleRemoved", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.TAGS_ADDED.id
    ? _c("TagsAdded", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.TAGS_REMOVED.id
    ? _c("TagsRemoved", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.WELCOME_MESSAGE_ADDED.id
    ? _c("WelcomeMessageAdded", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.WELCOME_MESSAGE_REMOVED.id
    ? _c("WelcomeMessageRemoved", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.BANNED_WORD_ADDED.id
    ? _c("BannedWordCreated", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.BANNED_WORD_REMOVED.id
    ? _c("BannedWordRemoved", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.TASK_WORKFLOW_CREATED.id
    ? _c("TaskWorkflwCreated", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.SETTINGS_UPDATED.id
    ? _c("SettingsUpdated", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.MAIL_ADDRESS_ADDED.id
    ? _c("MailAddressAdded", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.USER_ADDED_TO_DEPARTMENT.id
    ? _c("UserAddedToDepartment", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.USER_REMOVED_FROM_DEPARTMENT.id
    ? _c("UserRemovedFromDepartment", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.TASK_DELETED.id
    ? _c("TaskDeleted", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.CHANNEL_VISIBILITY_CHANGED.id
    ? _c("ChannelVisibilityChanged", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.CHANNEL_FORWARD_CONFIG_UPDATED.id
    ? _c("ChannelForwardConfigUpdated", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.CHANNEL_ZOHO_CONFIG_UPDATED.id
    ? _c("ChannelZohoConfigUpdated", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.CONTENT_ADDED.id
    ? _c("ContentAdded", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.CONTENT_REMOVED.id
    ? _c("ContentRemoved", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.CUSTOMER_GROUP_ADDED.id
    ? _c("CustomerGroupAdded", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.CUSTOMER_GROUP_REMOVED.id
    ? _c("CustomerGroupRemoved", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.CUSTOMER_GROUP_UPDATED.id
    ? _c("CustomerGroupUpdated", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.CHAT_ASSIGNED_TO_USER.id
    ? _c("ChatAssigned", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.CHAT_FORWARDED_TO_USER.id
    ? _c("ChatForwarded", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.USER_JOINED_TO_CHAT.id
    ? _c("ChatJoined", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.USER_LOGGED_IN.id
    ? _c("UserLoggedIn", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.TICKET_ASSIGNED_TO_USER.id
    ? _c("TicketAssigned", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.WHATSAPP_BROADCAST_CREATED.id
    ? _c("WhatsappBroadcastCreated", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.WHATSAPP_BROADCAST_COMPLETED.id
    ? _c("WhatsappBroadcastCompleted", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.WHATSAPP_BROADCAST_CANCELED.id
    ? _c("WhatsappBroadcastCancelled", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.WHATSAPP_BROADCAST_FAILED.id
    ? _c("WhatsappBroadcastFailed", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.TASK_WORKFLOW_DELETED.id
    ? _c("TaskWorkflowDeleted", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.TASK_WORKFLOW_RESTORED.id
    ? _c("TaskWorkflowRestored", { attrs: { activity: _vm.activity } })
    : _vm.activity.type ===
      _vm.ActivityTypes.TASK_WORKFLOW_PERMANENTLY_DELETED.id
    ? _c("TaskWorkflowPermanentlyDeleted", {
        attrs: { activity: _vm.activity },
      })
    : _vm.activity.type === _vm.ActivityTypes.BILLING_ADDRESS_UPDATED.id
    ? _c("BillingAddressUpdated", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.INVOICE_CREATED.id
    ? _c("InvoiceCreated", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.INVOICE_PAYMENT_RECEIVED.id
    ? _c("InvoicePaymentReceived", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.INVOICE_PAYMENT_FAILED.id
    ? _c("InvoicePaymentFailed", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.PAYMENT_METHOD_ADDED.id
    ? _c("PaymentMethodAdded", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.INVOICE_REFUNDED.id
    ? _c("InvoiceRefunded", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.LOGIN_FORM_ACTIVATED.id
    ? _c("LoginFormActivated", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.LOGIN_FORM_DEACTIVATED.id
    ? _c("LoginFormDeactivated", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.LOGIN_FORM_UPDATED.id
    ? _c("LoginFormUpdated", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.USER_REMOVED.id
    ? _c("UserRemoved", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.CONTACT_PROP_ADDED.id
    ? _c("ContactPropAdded", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.CONTACT_PROP_REMOVED.id
    ? _c("ContactPropRemoved", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.TASK_CREATED.id
    ? _c("TaskCreated", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.TASK_STAGE_CHANGED.id
    ? _c("TaskStageChanged", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.TASK_ASSIGNED_TO_USER.id
    ? _c("TaskAssignedToUser", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.TASK_UPDATE_PRIORITY.id
    ? _c("TaskUpdatedPriority", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.TASK_ADDED_TAGS.id
    ? _c("TaskAddedTags", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.TASK_REMOVED_TAGS.id
    ? _c("TaskRemovedTags", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.TASK_UPDATE_TITLE.id
    ? _c("TaskUpdateTitle", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.TASK_UPDATE_DESCRIPTION.id
    ? _c("TaskUpdateDescription", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.TASK_UPDATE_START_DATE.id
    ? _c("TaskUpdateStartDate", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.TASK_UPDATE_END_DATE.id
    ? _c("TaskUpdateEndDate", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.TASK_UPDATE_OWNER.id
    ? _c("TaskUpdateOwner", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.TASK_ADDED_FOLLOWERS.id
    ? _c("TaskAddedFollowers", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.TASK_REMOVED_FOLLOWERS.id
    ? _c("TaskRemovedFollowers", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.TASK_ADDED_COLLABORATORS.id
    ? _c("TaskAddedCollaborators", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.TASK_UPDATE_CHECKLIST.id
    ? _c("TaskUpdateChecklist", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.TASK_ADDED_SUBTASK.id
    ? _c("TaskAddedSubtask", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.TASK_REMOVED_SUBTASK.id
    ? _c("TaskRemovedSubtask", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.TASK_ADDED_ATTACHMENT.id
    ? _c("TaskAddedAttachment", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.TASK_COMPLETED.id
    ? _c("TaskComplet", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.TASK_ARCHIVED.id
    ? _c("TaskArchived", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.TASK_RESTORED.id
    ? _c("TaskRestored", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.TASK_UNARCHIVED.id
    ? _c("TaskUnarchived", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.WHATSAPP_CREDIT_LOW.id
    ? _c("WhatsappCreditLow", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.CHATBOT_CREATED.id
    ? _c("ChatbotCreated", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.CHATBOT_CREDIT_LOW.id
    ? _c("ChatBotCreditLow", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.CHATBOT_CREDIT_DONE.id
    ? _c("ChatBotCreditDone", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.AUTOMATION_TASK_CREDIT_LOW.id
    ? _c("AutomationTaskCreditLow", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.AUTOMATION_TASK_CREDIT_DONE.id
    ? _c("AutomationTaskCreditDone", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.SYSTEM_STATUS.id
    ? _c("SystemStatusChanged", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.CHATBOT_DELETED.id
    ? _c("ChatbotDeleted", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.CHATBOT_RESTORED.id
    ? _c("ChatbotRestored", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.CHATBOT_PUBLISHED.id
    ? _c("ChatbotPublished", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.PLAN_STARTED.id
    ? _c("PlanStarted", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.PLAN_CANCELED.id
    ? _c("PlanCanceled", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.WHATSAPP_V1_BOT_STATE_CHANGED.id
    ? _c("WhatsappV1BotStateChanged", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.WHATSAPP_V2_BOT_STATE_CHANGED.id
    ? _c("WhatsappV2BotStateChanged", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.WABA_SUPSIS_PARTNER_REMOVE.id ||
      _vm.activity.type ===
        _vm.ActivityTypes.WABA_SUPSIS_PARTNER_REMOVE_LEGACY.id
    ? _c("WabaSupsisPartnerRemove", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.WABA_SUPSIS_PARTNER_ADDED.id
    ? _c("WabaSupsisPartnerAdded", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.WABA_SUPSIS_ACCOUNT_DELETED.id ||
      _vm.activity.type ===
        _vm.ActivityTypes.WABA_SUPSIS_ACCOUNT_DELETED_LEGACY.id
    ? _c("WabaSupsisAccountDeleted", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.WABA_SUPSIS_ACCOUNT_VIOLATION.id
    ? _c("WabaSupsisAccountViolation", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.WABA_SUPSIS_AD_ACCOUNT_LINKED.id
    ? _c("WabaSupsisAdAccountLinked", { attrs: { activity: _vm.activity } })
    : _vm.activity.type ===
      _vm.ActivityTypes.WABA_SUPSIS_AUTH_INTL_PRICE_ELIGIBILITY_UPDATE.id
    ? _c("WabaSupsisAuthIntlPriceEligibilityUpdate", {
        attrs: { activity: _vm.activity },
      })
    : _vm.activity.type === _vm.ActivityTypes.WABA_SUPSIS_DISABLED_UPDATE.id
    ? _c("WabaSupsisDisabledUpdate", { attrs: { activity: _vm.activity } })
    : _vm.activity.type ===
      _vm.ActivityTypes.WABA_SUPSIS_MM_LITE_TERMS_SIGNED.id
    ? _c("WabaSupsisMmLiteTermsSigned", { attrs: { activity: _vm.activity } })
    : _vm.activity.type ===
      _vm.ActivityTypes.WABA_SUPSIS_PARTNER_APP_INSTALLED.id
    ? _c("WabaSupsisPartnerAppInstalled", { attrs: { activity: _vm.activity } })
    : _vm.activity.type ===
      _vm.ActivityTypes.WABA_SUPSIS_PARTNER_APP_UNINSTALLED.id
    ? _c("WabaSupsisPartnerAppUninstalled", {
        attrs: { activity: _vm.activity },
      })
    : _vm.activity.type ===
      _vm.ActivityTypes.WABA_SUPSIS_PARTNER_CLIENT_CERTIFICATION_STATUS_UPDATE
        .id
    ? _c("WabaSupsisPartnerClientCertificationStatusUpdate", {
        attrs: { activity: _vm.activity },
      })
    : _vm.activity.type ===
      _vm.ActivityTypes.WABA_SUPSIS_BUSINESS_PRIMARY_LOCATION_COUNTRY_UPDATE.id
    ? _c("WabaSupsisBusinessPrimaryLocationCountryUpdate", {
        attrs: { activity: _vm.activity },
      })
    : _vm.activity.type ===
      _vm.ActivityTypes.WABA_SUPSIS_VOLUME_BASED_PRICING_TIER_UPDATE.id
    ? _c("WabaSupsisVolumeBasedPricingTierUpdate", {
        attrs: { activity: _vm.activity },
      })
    : _vm.activity.type ===
      _vm.ActivityTypes.WABA_SUPSIS_MESSAGE_TEMPLATE_COMPONENTS_UPDATE.id
    ? _c("WabaSupsisMessageTemplateComponentsUpdate", {
        attrs: { activity: _vm.activity },
      })
    : _vm.activity.type ===
      _vm.ActivityTypes.WABA_SUPSIS_MESSAGE_TEMPLATE_STATUS_UPDATE.id
    ? _c("WabaSupsisMessageTemplateStatusUpdate", {
        attrs: { activity: _vm.activity },
      })
    : _vm.activity.type ===
      _vm.ActivityTypes.WABA_SUPSIS_TEMPLATE_CATEGORY_UPDATE.id
    ? _c("WabaSupsisTemplateCategoryUpdate", {
        attrs: { activity: _vm.activity },
      })
    : _vm.activity.type === _vm.ActivityTypes.RESERVATION_CREATED_PLAN.id
    ? _c("ReservationCreatedPlan", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.RESERVATION_UPDATED_PLAN.id
    ? _c("ReservationUpdatedPlan", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.RESERVATION_DELETED_PLAN.id
    ? _c("ReservationDeletedPlan", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.RESERVATION_CREATED.id
    ? _c("ReservationCreated", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.RESERVATION_UPDATED.id
    ? _c("ReservationUpdated", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.RESERVATION_DELETED.id
    ? _c("ReservationDeleted", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.CONTACT_OWNER_UPDATED.id
    ? _c("ContactOwnerUpdated", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.WHITE_LIST_ADDED.id
    ? _c("WhiteListAdded", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.WHITE_LIST_REMOVED.id
    ? _c("WhiteListRemoved", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.AUTO_REBALANCE_SUCCESS.id
    ? _c("AutoRebalanceSuccess", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.AUTO_REBALANCE_FAILED.id
    ? _c("AutoRebalanceFailed", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.AUTO_REBALANCE_DISABLED.id
    ? _c("AutoRebalanceDisabled", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.AUTOMATION_CREATED.id
    ? _c("AutomationCreated", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.AUTOMATION_DELETED.id
    ? _c("AutomationDeleted", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.AUTOMATION_RESTORED.id
    ? _c("AutomationRestored", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.AUTOMATION_PUBLISHED.id
    ? _c("AutomationPublished", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.AUTOMATION_UNPUBLISHED.id
    ? _c("AutomationUnpublished", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.AUTOMATION_UPDATED.id
    ? _c("AutomationUpdated", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.FORM_CREATED.id
    ? _c("FormCreated", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.FORM_UPDATED.id
    ? _c("FormUpdated", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.FORM_DELETED.id
    ? _c("FormDeleted", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.FORM_RESTORED.id
    ? _c("FormRestored", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.FORM_DOWNLOADED.id
    ? _c("FormDownloaded", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.USER_ROLE_CHANGED.id
    ? _c("UserRoleChanged", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.USER_PASSWORD_CHANGED.id
    ? _c("UserPasswordChanged", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.USER_EMAIL_CHANGED.id
    ? _c("UserEmailChanged", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.USER_NAME_CHANGED.id
    ? _c("UserNameChanged", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.USER_PHONE_CHANGED.id
    ? _c("UserPhoneChanged", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.USER_DISABLED.id
    ? _c("UserDisabled", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.ROLE_UPDATED.id
    ? _c("RoleUpdated", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.TASK_WORKFLOW_UPDATED.id
    ? _c("TaskWorkflowUpdated", { attrs: { activity: _vm.activity } })
    : _vm.activity.type ===
      _vm.ActivityTypes.TASK_WORKFLOW_PIPELINE_STAGE_ADDED.id
    ? _c("TaskWorkflowPipelineStageAdded", {
        attrs: { activity: _vm.activity },
      })
    : _vm.activity.type ===
      _vm.ActivityTypes.TASK_WORKFLOW_PIPELINE_STAGE_UPDATED.id
    ? _c("TaskWorkflowPipelineStageUpdated", {
        attrs: { activity: _vm.activity },
      })
    : _vm.activity.type ===
      _vm.ActivityTypes.TASK_WORKFLOW_PIPELINE_STAGE_DELETED.id
    ? _c("TaskWorkflowPipelineStageDeleted", {
        attrs: { activity: _vm.activity },
      })
    : _vm.activity.type === _vm.ActivityTypes.DRIVE_FOLDER_CREATED.id
    ? _c("DriveFolderCreated", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.DRIVE_FOLDER_DELETED.id
    ? _c("DriveFolderDeleted", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.DRIVE_FOLDER_RENAMED.id
    ? _c("DriveFolderRenamed", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.DRIVE_FILE_ADDED.id
    ? _c("DriveFileAdded", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.DRIVE_FILE_DELETED.id
    ? _c("DriveFileDeleted", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.TASK_MODULE_RULES_ENABLED.id
    ? _c("TaskModuleRulesEnabled", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.TASK_MODULE_RULES_DISABLED.id
    ? _c("TaskModuleRulesDisabled", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.TASK_MODULE_RULES_RULE_ADDED.id
    ? _c("TaskModuleRulesRuleAdded", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.TASK_MODULE_RULES_RULE_DELETED.id
    ? _c("TaskModuleRulesRuleDeleted", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.TASK_MODULE_RULES_RULE_UPDATED.id
    ? _c("TaskModuleRulesRuleUpdated", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.TASK_MODULE_RULES_RULE_ENABLED.id
    ? _c("TaskModuleRulesRuleEnabled", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.TASK_MODULE_RULES_RULE_DISABLED.id
    ? _c("TaskModuleRulesRuleDisabled", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.CONTACT_MODULE_RULES_ENABLED.id
    ? _c("ContactModuleRulesEnabled", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.CONTACT_MODULE_RULES_DISABLED.id
    ? _c("ContactModuleRulesDisabled", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.CONTACT_MODULE_RULES_RULE_ADDED.id
    ? _c("ContactModuleRulesRuleAdded", { attrs: { activity: _vm.activity } })
    : _vm.activity.type ===
      _vm.ActivityTypes.CONTACT_MODULE_RULES_RULE_UPDATED.id
    ? _c("ContactModuleRulesRuleUpdated", { attrs: { activity: _vm.activity } })
    : _vm.activity.type ===
      _vm.ActivityTypes.CONTACT_MODULE_RULES_RULE_DELETED.id
    ? _c("ContactModuleRulesRuleDeleted", { attrs: { activity: _vm.activity } })
    : _vm.activity.type ===
      _vm.ActivityTypes.CONTACT_MODULE_RULES_RULE_ENABLED.id
    ? _c("ContactModuleRulesRuleEnabled", { attrs: { activity: _vm.activity } })
    : _vm.activity.type ===
      _vm.ActivityTypes.CONTACT_MODULE_RULES_RULE_DISABLED.id
    ? _c("ContactModuleRulesRuleDisabled", {
        attrs: { activity: _vm.activity },
      })
    : _vm.activity.type === _vm.ActivityTypes.DEVELOPER_TOKEN_CHANGED.id
    ? _c("DeveloperTokenChanged", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.TABLE_CREATED.id
    ? _c("TableCreated", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.TABLE_DELETED.id
    ? _c("TableDeleted", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.TABLE_RESTORED.id
    ? _c("TableRestored", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.TABLE_PERMANENTLY_DELETED.id
    ? _c("TablePermanentlyDeleted", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.TABLE_FIELD_ADDED.id
    ? _c("TableFieldAdded", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.TABLE_FIELD_UPDATED.id
    ? _c("TableFieldUpdated", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.TABLE_FIELD_DELETED.id
    ? _c("TableFieldDeleted", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.TABLE_VIEW_ADDED.id
    ? _c("TableViewAdded", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.TABLE_VIEW_UPDATED.id
    ? _c("TableViewUpdated", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.TABLE_VIEW_DELETED.id
    ? _c("TableViewDeleted", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.TABLE_PAGE_ADDED.id
    ? _c("TablePageAdded", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.TABLE_PAGE_UPDATED.id
    ? _c("TablePageUpdated", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.TABLE_PAGE_DELETED.id
    ? _c("TablePageDeleted", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.TABLE_WIDGET_ADDED.id
    ? _c("TableWidgetAdded", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.TABLE_WIDGET_UPDATED.id
    ? _c("TableWidgetUpdated", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.TABLE_WIDGET_DELETED.id
    ? _c("TableWidgetDeleted", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.TABLE_PERMISSION_CHANGED.id
    ? _c("TablePermissionChanged", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.TABLE_DATA_DOWNLOADED.id
    ? _c("TableDataDownloaded", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.TABLE_DATA_IMPORTED.id
    ? _c("TableDataImported", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.TABLE_DATA_BATCH_UPDATED.id
    ? _c("TableDataBatchUpdated", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.TABLE_DATA_BATCH_DELETED.id
    ? _c("TableDataBatchDeleted", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.CONTACT_BATCH_UPDATED.id
    ? _c("ContactBatchUpdated", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.CHAT_DATA_DOWNLOADED.id
    ? _c("ChatDataDownloaded", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.WEB_APP_CREATED.id
    ? _c("WebAppCreated", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.WEB_APP_UPDATED.id
    ? _c("WebAppUpdated", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.WEB_APP_DELETED.id
    ? _c("WebAppDeleted", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.WEB_TAB_CREATED.id
    ? _c("WebTabCreated", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.WEB_TAB_UPDATED.id
    ? _c("WebTabUpdated", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.WEB_TAB_DELETED.id
    ? _c("WebTabDeleted", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.MODULE_CREATED.id
    ? _c("ModuleCreated", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.MODULE_UPDATED.id
    ? _c("ModuleUpdated", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.MODULE_DELETED.id
    ? _c("ModuleDeleted", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.RELATION_CREATED.id
    ? _c("RelationCreated", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.RELATION_UPDATED.id
    ? _c("RelationUpdated", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.VOICE_AGENT_CREATED.id
    ? _c("VoiceAgentCreated", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.VOICE_AGENT_UPDATED.id
    ? _c("VoiceAgentUpdated", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.VOICE_AGENT_DELETED.id
    ? _c("VoiceAgentDeleted", { attrs: { activity: _vm.activity } })
    : _vm.activity.type ===
      _vm.ActivityTypes.VOICE_AGENT_PHONE_NUMBER_INBOUND_AGENT_CHANGED.id
    ? _c("VoiceAgentPhoneNumberInboundAgentChanged", {
        attrs: { activity: _vm.activity },
      })
    : _vm.activity.type ===
      _vm.ActivityTypes.VOICE_AGENT_PHONE_NUMBER_OUTBOUND_AGENT_CHANGED.id
    ? _c("VoiceAgentPhoneNumberOutboundAgentChanged", {
        attrs: { activity: _vm.activity },
      })
    : _vm.activity.type === _vm.ActivityTypes.VOICE_AGENT_BATCH_CALL_CREATED.id
    ? _c("VoiceAgentBatchCallCreated", { attrs: { activity: _vm.activity } })
    : _vm.activity.type ===
      _vm.ActivityTypes.VOICE_AGENT_KNOWLEDGE_BASE_CREATED.id
    ? _c("VoiceAgentKnowledgeBaseCreated", {
        attrs: { activity: _vm.activity },
      })
    : _vm.activity.type ===
      _vm.ActivityTypes.VOICE_AGENT_KNOWLEDGE_BASE_DELETED.id
    ? _c("VoiceAgentKnowledgeBaseDeleted", {
        attrs: { activity: _vm.activity },
      })
    : _vm.activity.type === _vm.ActivityTypes.CUSTOM.id
    ? _c("CustomActivity", { attrs: { activity: _vm.activity } })
    : _c("div", [_vm._v("\n    " + _vm._s(_vm.activity.type) + "\n")])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }